import React from 'react';
import { Link } from 'react-router-dom';
import marca from '../assets/marca.png';

export default function HeaderPolicity() {
  return (
    <header className="flex bg-primary flex-wrap md:justify-start md:flex-nowrap z-50 w-full text-sm py-3 md:py-0">
      <nav className="max-w-[85rem] w-full mx-auto px-4 md:px-6 lg:px-8" aria-label="Global">
        <div className="relative md:flex md:items-center md:justify-between">
          <div className="flex items-center justify-between">
            <div className="flex gap-1 items-center">
              <Link to="/politica-de-privacidade" aria-current="page">
                <div className="flex gap-1 items-center">
                  <img
                    src={marca}
                    className="w-11 h-11 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-14 lg:h-14"
                    alt="Marca"
                  />
                  <span className="text-white font-medium text-lg sm:text-sm md:text-base lg:text-lg">
                    Fonotherapp
                  </span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
